import React from 'react';
import '../CSS/Skills.css'; 
import e7 from "../Images4/cs.png"
import e8 from "../Images4/msproject2.png"
import e9 from "../Images4/acad2.png"
import AAS from "../Images4/prima2.png"
import { useSelector } from 'react-redux';





const Softwares = [
  { id: 1, image: e8, title: "MS Project" },
  
  { id: 4, image: e9, title: "AutoCAD" },
  { id: 6, image: AAS, title: "Primavera P6" },
  { id: 3, image: e7, title: "Civil Soft" },
];




const Skills = () => {
  const theme = useSelector((state)=>state.theme);
  console.log(theme)


  return (
    <div className='Skills' style={{
      backgroundColor:theme?"rgba(0,0,0,0.1)":"rgba(0,0,0,0.8)",
      color:theme?"#1e293b":"white"}}>
      <h1>MY SOFTWARE SKILLS</h1>
      {/* <div style={{backgroundColor:"lightgray",width:"100%",height:"5px"}}></div> */}
      <p>Skilled in utilizing industry-standard software such as AutoCAD, MS Project, Civil Soft, and Primavera P6 to support the full lifecycle of AEC (Architecture, Engineering, and Construction) projects. Capable of developing, reviewing, editing, and finalizing technical drawings, models, schedules, and blueprints. Collaborates effectively with design teams to incorporate stakeholder feedback and implement design revisions, ensuring alignment with project goals and directives.</p>
      
      <div className='EngineeringWrap'>
        <div className="Engineering">
      {Softwares.map((Software, index) => (
        <div key={index} className='SoftwareWrap'>
            <div className="SoftwareImgWrap">
          <img src={Software.image} alt={`Image ${index + 1}`} />
        </div>
        <span>{Software.title}</span>
        </div>
      ))}
    </div>
    </div>
    {/* <OtherSkills/> */}
      
    </div>
  );
};

export default Skills;
